// extracted by mini-css-extract-plugin
module.exports = {"seriesHome":"styles_seriesHome__TFLtL"};